export const initCertificatesLightbox = (): void => {
  const galleries = document.querySelectorAll<HTMLElement>(
    "[data-certificates-gallery]",
  );

  if (galleries.length === 0) return;

  // Wait for jQuery and Magnific Popup to be ready
  if (
    typeof (window as any).$ !== "undefined" &&
    typeof (window as any).$.fn.magnificPopup !== "undefined"
  ) {
    const $ = (window as any).$;

    $("[data-certificates-gallery]").each(function (this: HTMLElement) {
      $(this).magnificPopup({
        delegate: ".certificate-card__lightbox-link", // child items selector, by clicking on it popup will open
        type: "image",
        gallery: {
          enabled: true,
          navigateByImgClick: true,
          preload: [0, 1], // Will preload 0 - before current, and 1 after the current image
        },
        image: {
          titleSrc: function (item: any) {
            return item.el.attr("title") || "";
          },
        },
        mainClass: "mfp-with-zoom", // Optional zoom effect
        zoom: {
          enabled: true,
          duration: 300,
          easing: "ease-in-out",
        },
      });
    });

    console.log("[Certificates] Lightbox initialized.");
  }
};
